module.exports = __webpack_public_path__ + "ssygl/img/slhy.47104654.svg";